import { Injectable } from '@angular/core';

import { HttpClientService } from 'app/shared/service/http-client.service';

@Injectable({ providedIn: 'root' })
export class ResourcesService {
  constructor(private readonly httpClientService: HttpClientService) {}

  getDownloadUrl(
    url: string,
    params?: {
      expires?: number;
      keyName?: string;
      disposition?: string;
    },
  ) {
    return this.httpClientService.post<string>('resources/download', { ...params, url });
  }
}
